import React from "react";
export default function RulesetIndicator(props) {
  return /*#__PURE__*/React.createElement("em", props, "\u2020 Requires Exception Request");
}